import React, { useState, useEffect } from "react";
import dranoop from "../../assets/images/dr_anoop.jpg";
const images = [
  {
    src: "https://images.openai.com/thumbnails/9bc7d4eb23b1c0d1dd9dfcb5c08b803f.jpeg",
    alt: "Clinic Interior",
  },
  {
    src: dranoop,
    alt: "Dr Anoop Consultation",
  },
  {
    src: "https://anoopjhurani.com/wp-content/uploads/2025/02/home_image_dr_jhurani.png",
    alt: "Treatment Room",
  },
  {
    src: "https://content.jdmagicbox.com/v2/comp/bhopal/s9/0755px755.x755.101207095250.n7s9/catalogue/dr-anoop-choudhary-malviya-nagar-bhopal-homeopathic-doctors-3e0c78fdon.jpg?crop=350%3A350%3B%2A%2C%2A&fit=around%7C350%3A350",
    alt: "Dr. Anoop Choudhary",
  },
  {
    src: "https://nbccindia.in/images/news/NIT_Patna_072024.jpeg",
    alt: "Clinic Interior",
  },
];

function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImg, setCurrentImg] = useState({ src: "", alt: "" });

  const openLightbox = (img) => {
    setCurrentImg(img);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate__animated animate__fadeInUp">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4 font-poppins">
            Our Gallery
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto font-poppins">
            Take a look at our clinic and facilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((img, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-lg animate__animated animate__fadeInUp cursor-pointer"
              onClick={() => openLightbox(img)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-[300px] object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center animate__animated animate__fadeIn"
          onClick={(e) => e.target === e.currentTarget && closeLightbox()}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <img
            src={currentImg.src}
            alt={currentImg.alt}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
        </div>
      )}
    </section>
  );
}

export default Gallery;
